<template>
  <section id="about" class="n2-seccion n4-notario" v-if="PN?.Mostrar">
    <div class="n2-contenedor">
      <div class="n4-cabeza n2-aparece">
        <span class="n4-cabeza__num" aria-hidden="true">{{ numero('about') }}</span>
        <h2 class="n4-titular" v-html="PN.Titulo?.Texto || tituloSeccion(NOTARIA, 'Notario', $t)"></h2>
      </div>
      <blockquote v-if="cita" class="n4-notario__cita n2-aparece">{{ cita }}</blockquote>
      <div class="n4-notario__rejilla" :class="{ 'n4-notario__rejilla--invertida': PN.ImageLeft === false }">
        <figure v-if="PN.Imagen" class="n4-notario__foto n2-aparece">
          <img :src="imagenIDtoSRC(PN.Imagen)" :alt="'Fotografía de ' + NOTARIA.Nombre + ' - Notario'" loading="lazy" />
          <figcaption>{{ NOTARIA.Nombre }}</figcaption>
        </figure>
        <div class="n4-notario__texto n2-aparece">
          <div v-if="PN.Descripcion?.Texto" class="n2-texto-rico n4-columnas n4-capitular" :style="alineacionTexto(PN.Descripcion.css)" v-html="PN.Descripcion.Texto"></div>
          <NuxtLink v-if="NOTARIA.Theme.Menu?.ShowNotarios && NOTARIA.Notarios?.length" :to="getLocalePath('/notarios')" class="n2-enlace">
            {{ tituloSeccion(NOTARIA, 'Notario', $t) }} <span aria-hidden="true">→</span>
          </NuxtLink>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useStore } from '../../store/index'
import { useUtils } from '#imports'
import { tituloSeccion, textoPlano, alineacionTexto } from '../../composables/useNotaria2'
import { useSumario } from '../../composables/useNotaria4'
const store = useStore()
const { NOTARIA } = storeToRefs(store)
const { imagenIDtoSRC, $t, getLocalePath } = useUtils()
// Panel: Inicio → Palabras del notario
const PN = computed(() => NOTARIA.value?.Theme?.Home?.PN)
const { numero } = useSumario()
// Cita destacada: la primera frase del texto si es corta; si no, hasta la primera coma o punto y coma
const cita = computed(() => {
  const texto = textoPlano(PN.value?.Descripcion?.Texto || '').trim()
  const frase = texto.match(/^.{20,180}?[.!?](?=\s|$)/)?.[0]
  if (frase) return frase
  const trozo = texto.match(/^(.{40,180}?)[,;:](?=\s)/)?.[1]
  return trozo ? trozo + '…' : ''
})
</script>
